<script setup lang="ts" generic="T extends { id: string }">
import type { PropType } from 'vue';

import { computed, onMounted, onUnmounted, ref } from 'vue';

import CarouselDesktop from './carousel/CarouselDesktop.vue';
import CarouselMobile from './carousel/CarouselMobile.vue';

defineProps({
  items: {
    type: Array as PropType<Array<T>>,
    required: true,
  },
  minItemWidth: {
    type: Number,
    required: true,
  },
  maxItemWidth: {
    type: Number,
    required: true,
  },
  gap: {
    type: Number,
    default: 20,
  },
});

const $root = ref<HTMLElement>();
const carouselSize = ref(0);
let observer: ResizeObserver | undefined;

const carouselComponent = computed(() => {
  if (carouselSize.value < 450) {
    return CarouselMobile;
  }
  else {
    return CarouselDesktop;
  }
});

function updateCarouselSize() {
  const root = $root.value;
  if (root == null)
    return;
  carouselSize.value = root.getBoundingClientRect().width;
}

onMounted(() => {
  const root = $root.value;
  if (root == null) {
    throw new Error('Carousel root is null');
  }
  updateCarouselSize();
  observer = new ResizeObserver(updateCarouselSize);
  observer.observe(root);
});

onUnmounted(() => {
  observer?.disconnect();
});
</script>

<template>
  <div ref="$root" class="carousel-root">
    <component :is="carouselComponent" :items :min-item-width :max-item-width :gap :style="$attrs?.style">
      <template #item="{ item }">
        <slot name="item" :item>
          item
        </slot>
      </template>
    </component>
  </div>
</template>
